import React, { useState, useEffect, useRef } from "react";

function useComponentVisible(initialIsVisible) {
    const [isComponentVisible, setIsComponentVisible] = useState(
        initialIsVisible
    );
    const ref = useRef(null);

    const handleHideDropdown = (event) => {
        if (event.key === "Escape") {
            setIsComponentVisible(false);
        }
    };

    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            if (isComponentVisible)
                event.stopPropagation()
            setIsComponentVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener("keydown", handleHideDropdown, true);
        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("keydown", handleHideDropdown, true);
            document.removeEventListener("click", handleClickOutside, true);
        };
    })

    return { ref, isComponentVisible, setIsComponentVisible };
}

const ModalMenuClose = ({ contentButton, contentModal, classNameContentModal, classNameContentButton, isShowModalInput }) => {
    const {
        ref,
        isComponentVisible,
        setIsComponentVisible
    } = useComponentVisible(false);
    return (
        <div className="parent-width relative" ref={ref}>
            <div
                className={"parent-width"}
                onClick={() =>
                    isShowModalInput ?
                        setIsComponentVisible(true)
                        :
                        isComponentVisible
                            ? setIsComponentVisible(false)
                            : setIsComponentVisible(true)
                }
            >
                {contentButton}
            </div>
            {isComponentVisible &&
                <div onClick={() => { setIsComponentVisible(false) }}>
                    {contentModal}
                </div>
            }
        </div>
    );
};

export default ModalMenuClose;
